﻿import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { APIHeaderService } from '../../_services/header/API-header';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { BadWordsApiService } from 'src/app/_root/Trai_module/_services/bad-words/bad-words-api.service';
//import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';



export interface headerTypeValues {
	key: string
	value: string
}

const uri = "http://10.163.2.8:8082/fileupload";

@Component({
	selector: 'app-new-header-registration',
	templateUrl: './new-header-registration.component.html',
	styleUrls: ['./new-header-registration.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class HeaderRegComponent implements OnInit {
	email: any;
	mobileno: any;
	OrgType: any;

	constructor(private fb: FormBuilder,
		private es: APILoginService,
		private ls: APIEntityService,
		private hs: APIHeaderService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private bw: BadWordsApiService,
		private router: Router,
		private modalService: BsModalService,
	) {
		this._route.params.subscribe((params) => {
		})


	}

	headerForm: FormGroup;
	selectedValue: String;


	photoName: any;
	photoName1: any;
	fileExtension: any;
	fileExtension1: any;
	fileExtensionMessage: any;
	photoContent: any;
	uploader: string[];
	fileExtensionError: boolean = false;
	fileSizeError1: boolean = false;
	fileSizeError2: boolean = false;
	file1ExtensionError: boolean = false;
	file1SizeError1: boolean = false;
	file1SizeError2: boolean = false;

	hTypeDisabled: boolean = false;
	//public disableSelected : boolean = false;
	ctgrDisabled: boolean = false;
	tmDisabled: boolean = false;
	headerDisabled: boolean = false;
	categoryErr: boolean = false;

	file1ExtensionMessage: any;

	public headertypedivshow: boolean = false;
	myfiles: any[] = [];
	docfiles1: any;
	docfiles2: any;
	IndCategory: any;
	OrgName: any;
	IndustryType: any;
	IndustrySector: any;

	entityId: any;
	header_id: any;
	headerExistFlag: boolean = false;
	isPromotion: boolean = false;
	isOtherGov: boolean = false;
	isOtherNonGov: boolean = false;
	category: any;
	headType: any;
	headerN: any;
	data: any;
	principalEntityId: any;
	mobileNumber: any;
	emailId: any;
	emailIdSession: any;
	mobileNumberSession: any;
	mailStatus: boolean = false;
	mobileStatus: boolean = false;

	categoryhide: boolean = true;
	document1: any[] = [];
	document2: any[] = [];
	addDocFlag: boolean = false;
	errDoc: boolean = false;
	headerIdGeneration: any;
	entityType: any;
	mobileEmailFlag: boolean = false;
	headernonExistFlag: boolean = false;
	tmidFlag: boolean = true;
	tmidfalg1: boolean = false;
	modalRef: any;
	isNumCheckadres1: boolean = false;
	isNumCheckadres2: boolean = false;
	entityClass: any;
	tmidDlt: any;


	get f() { return this.headerForm.controls; }

	attachmentList: any = [];


	public categoryy = [
		{ name: "1 Banking / Insurance / Financial products / credit cards", value: 1 },
		{ name: "2 Real Estate", value: 2 },
		{ name: "3 Education", value: 3 },
		{ name: "4 Health", value: 4 },
		{ name: "5 Consumer Goods and Automobiles", value: 5 },
		{ name: "6 Communication / Broadcasting / Entertainment / IT", value: 6 },
		{ name: "7 Tourism and Leisure", value: 7 },
		{ name: "8 Food and Beverages", value: 8 },
		{ name: "0 None of the Above", value: 0 },
	]

	//Added for Hclass
	public hdervalidity = [
		{ value: "15", viewValue: "15" },
		{ value: "30", viewValue: "30" },
		{ value: "45", viewValue: "45" },
		{ value: "60", viewValue: "60" },

	]

	headerType1: headerTypeValues[] = [
		{ key: 'P', value: 'Promotional' },
		{ key: 'T', value: 'Transactional' },
		{ key: 'SI', value: 'Service-Implicit' },
		{ key: 'SE', value: 'Service-Explicit' }
	]

	//Added for Hclass
	temporaryHeader = 'false';
	public headerclas = [
		{ value: "Permanent", viewValue: "Permanent" },
		{ value: "Temporary", viewValue: "Temporary" },


	]

	ngOnInit() {

		this.headerForm = this.fb.group({

			//entity_name: ['', [Validators.required]],
			entity_name: ['',],
			industry_category: ['',],
			mobileno: ['', [Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)]],
			//header_email: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],
			//header_email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._-]+@[A-Za-z0-9._-]+\\.[a-z]{2,20}')]],
			header_email: ['',],	
			header: ['', Validators.required],
			emailotpno: ['', [Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
			mobileotpno: ['', [Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
			category: ['',[Validators.required]],
			//Added for Hclass
			hclass: ['', [Validators.required]],
			validity: [''],
			Validity_till: [''],
			headerType: ['', [Validators.required]],
			nature_business: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]],
			uploader: ['',],
			uploader1: ['',],
			desc_header: ['', [Validators.required, Validators.maxLength(250), Validators.minLength(1)]],
			doc_type: [''],
			doc_type1: [''],
			//tmid:['',],
			tmid: ['', [Validators.pattern(/^[a-zA-Z0-9]*$/)]],
			tm_name: ['',],
			industry_type: ['',],
			industry_sector: ['',],
		});//end of headerForm

		this.entityType = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE);
		this.IndCategory = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE); //INDUSTRYCATEGORY
		this.OrgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
		this.IndustrySector = this.db.get(Constants.SESSSION_STORAGE, Constants.INDUSTRYSECTOR);
		this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		this.emailIdSession = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
		this.mobileNumberSession = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO);
		this.entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);

		//Added for Government
		if (this.IndCategory == "G") {
			for (let i = 0; i < this.headerclas.length; i++) {
				if (this.headerclas[i].value == "Temporary") {
					this.headerclas.splice(i, 1)
				}
			}

			this.headerForm.controls['hclass'].setValue("Permanent");
		}

		if (this.entityClass == "TM") {
			this.headerForm.disable();
			this.router.navigateByUrl('/');
		}
		if (this.entityId == null || this.entityId == "null") {
			this.router.navigateByUrl('/');
		}

		this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, this.mobileNumberSession);
		this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);

		this.emailId = this.emailIdSession;
		this.mobileNumber = this.mobileNumberSession;

		this.fetchDLTEntityDetails(this.entityId);
		this.onloadInitialValues(this.entityId, this.mobileNumberSession);
		this.fetchIndDetailsfrmDB(this.entityId);

	}//end of oninit

	focusOutFunction(name) {
		console.log(name.value);
		if (name.value === undefined || '') {
			return true;
		}
		var numbers = /^[0-9@!#\$\^%&*()+=\-\[\]\\\';,\.\/\{\}\|\":<>\? ]+$/;
		let adrsValue = name.value.match(numbers);
		console.log("adrsValue ", adrsValue);
		if (adrsValue) {
			this.isNumCheckadres1 = true;
		} else {
			this.isNumCheckadres1 = false;

		}
	};
	focusOutFunction1(name) {
		console.log(name.value);
		if (name.value === undefined || '') {
			return true;
		}
		var numbers = /^[0-9@!#\$\^%&*()+=\-\[\]\\\';,\.\/\{\}\|\":<>\? ]+$/;
		let adrsValue = name.value.match(numbers);
		console.log("adrsValue2 ", adrsValue);

		if (adrsValue) {
			this.isNumCheckadres2 = true;
		} else {
			this.isNumCheckadres2 = false;

		}
	};


	//Added for Hclass
	onselectValidity(event) {
		let newdt;
		const date = new Date();
		switch (event.value) {
			case "15":
				var valitytill = new Date().setDate(date.getDate() + 15);
				break;
			case "30":
				var valitytill = new Date().setDate(date.getDate() + 30);
				break;
			case "45":
				var valitytill = new Date().setDate(date.getDate() + 45);
				break;
			case "60":
				var valitytill = new Date().setDate(date.getDate() + 60);
				break;
		}
		newdt = formatDate(valitytill, 'yyyy-MM-dd', 'en-US', '+0530');
		this.headerForm.controls['Validity_till'].setValue(newdt)
	}


	changeTMID(searchId: string) {
		let validCheck = this.headerForm.controls;
		if (searchId.length >= 1 && !validCheck["tmid"].invalid) {
			this.hs.fetchTMName(searchId)
				.subscribe((r) => {
					this.tmidFlag = false;
					if (r.result == null || r.result == "null") {
						this.headerForm.controls['tm_name'].setValue("NA");
						this.tmidFlag = false;

					}
					else if (r.result) {
						this.headerForm.controls['tm_name'].setValue(r.result);
						this.tmidFlag = true;
						this.tmidDlt = searchId;
						// console.log("this.tmidDlt ",this.tmidDlt);
					}
				})
		}

	}

	fetchIndDetailsfrmDB(entityId) {
		this.hs.fetchIndDetailsfrmDB(entityId)
			.subscribe((r) => {
				console.log("r ", r);
				if (r !== undefined && r !== null) {
					this.headerForm.controls['industry_type'].setValue(r.Industry);
					this.headerForm.controls['industry_sector'].setValue(r.Sector);
				}

			})
	}


	fileEvent(event): any {

		var file = event.target.files[0];
		this.photoName = file.name;

		var allowedExtensions =
			["jpg", "pdf"];
		this.fileExtension = this.photoName.split('.').pop();

		if (this.isInArray(allowedExtensions, this.fileExtension)) {
			this.fileExtensionError = false;
			this.fileExtensionMessage = ""
			alert("Invalid File 1 formate");
		} else {
			this.fileExtensionMessage = "Only photos allowed!!"
			alert("Invalid File 2 formate");
			this.fileExtensionError = true;
		}

		if (file) {
			var reader = new FileReader();
			reader.onloadend = (e: any) => {
				var contents = e.target.result;
				this.photoContent = contents;
			}
			reader.readAsDataURL(file);
		} else {
			alert("Failed to load file");
		}
	}


	/*- checks if word exists in array -*/
	isInArray(array, word) {
		return array.indexOf(word.toLowerCase()) > -1;
	}

	onloadInitialValues(entityId, mobile) {
		//this.hs.fetchEntityinHeadTempTable(entityId,mobile)

		this.hs.fetchEntityinHeadTempTable(entityId)
			.subscribe((r) => {

				if (r.result == "" || r.result == undefined) {
					this.headerIdGeneration = true;

					this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);
					this.mobileNumber = mobile;
					this.headerForm.controls['header_email'].setValue(this.emailIdSession);
					this.headerForm.controls['mobileno'].setValue(mobile);
				}
				else {
					this.headerIdGeneration = r.result[0].HeaderFlag;

					if (r.result[0].HeaderFlag == "false") {

						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, mobile);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);
						this.headerForm.controls['header_email'].setValue(this.emailIdSession);
						this.headerForm.controls['mobileno'].setValue(mobile);

					}
					else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "true" &&
						r.result[0].MVerifyFlag == "true")) {
						this.headerForm.controls['header_email'].setValue(r.result[0].EmailId);
						this.headerForm.controls['mobileno'].setValue(r.result[0].MobileNumber);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, r.result[0].MobileNumber);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, r.result[0].EmailId);
					}
					else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "true" &&
						r.result[0].MVerifyFlag == "false")) {
						this.headerForm.controls['header_email'].setValue(r.result[0].EmailId);
						this.headerForm.controls['mobileno'].setValue(mobile);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, mobile);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, r.result[0].EmailId);
					}
					else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "false" &&
						r.result[0].MVerifyFlag == "true")) {
						//console.log("fetch M from heademailverify flag, fetch email from entity table");
						this.headerForm.controls['mobileno'].setValue(r.result[0].MobileNumber);
						this.headerForm.controls['header_email'].setValue(this.emailIdSession);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, r.result[0].MobileNumber);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);
					}
					else {
						this.headerForm.controls['mobileno'].setValue(this.mobileNumberSession);
						this.headerForm.controls['header_email'].setValue(this.emailIdSession);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, this.mobileNumberSession);
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);
					}
				}
			})


	}



	fetchDLTEntityDetails(entityId) {

		this.hs.fetchDLTEntityDetails(entityId)
			.subscribe((r) => {
				if (r[0] !== undefined && r[0] !== null) {
					this.OrgType = r[0].etype;

					switch (r[0].etype) {
						case 'P':
							this.headerForm.controls['industry_category'].setValue('Private');
							break;
						case 'G':
							this.headerForm.controls['industry_category'].setValue('Government');
							break;
						case 'S':
							this.headerForm.controls['industry_category'].setValue('SEBI');
							break;
						case 'U':
							this.headerForm.controls['industry_category'].setValue('Public Limited Company');
							break;
						case 'O':
							this.headerForm.controls['industry_category'].setValue('Others');
							break;
						default:
							this.headerForm.controls['industry_category'].setValue('');
							break;
					}

					this.headerForm.controls['entity_name'].setValue(r[0].name);
					this.headerForm.controls['entity_name'].disable();
					this.headerForm.controls['industry_category'].disable();
				}
			})

	}

	headerinfo(event) {
		//console.log("header typeof.." + event.value);
		if (event.value == "Other") {
			this.headertypedivshow = true;
		}
		else {
			this.headertypedivshow = false;
		}

	}


	onChangeCategory(category) {
		this.category = category;
		this.categoryhide = true;
		if (this.headType === "P") {
			let headerName = this.headerForm.get("header").value;
			let firstChar = headerName.charAt(0);
			console.log("firstChar :", firstChar);
			this.categoryhide = false;

			if (firstChar == category) {
				this.categoryErr = false;
			}
			else {
				this.categoryErr = true;
			}
			

		}

	}

	//Added for Hclass
	onChangeheaderclass(event) {

		console.log("----------event-------------", event, event.value)
		if (event.value === "Temporary") {
			this.temporaryHeader = 'true'
			this.headerForm.controls['validity'].setValidators([Validators.required])
			this.headerForm.controls['validity'].updateValueAndValidity();
		}
		else {
			this.temporaryHeader = 'false'
		}
	}
	setField(selected) {

		this.isPromotion = false;
		this.isOtherGov = false;
		this.isOtherNonGov = false;
		this.headType = selected;
		//commented below to make ctgr mandatory
		// this.headerForm.controls["category"].enable();
		// this.headerForm.controls["category"].setValidators([Validators.required]);
		// this.headerForm.controls["category"].updateValueAndValidity();
		if (selected === "P" && (this.category !== undefined || this.category !== null)) {
		
			this.categoryhide = false;
			this.isPromotion = true;

			this.headerForm.controls["header"].enable();
			this.headerForm.controls['header'].setValidators([Validators.required, Validators.pattern("^([0-9]{6})$")]);
			this.headerForm.controls["header"].updateValueAndValidity();
			
		}
		if ((this.category == undefined || this.category == null) && selected === "P") {
			
			this.categoryhide = false;
			this.isPromotion = true;
			this.headerForm.controls["header"].enable();
			this.headerForm.controls['header'].setValidators([Validators.required, Validators.pattern("^([0-9]{6})$")]);
			this.headerForm.controls["header"].updateValueAndValidity();


			// this.headerForm.controls["category"].enable();
			// this.headerForm.controls["category"].setValidators([Validators.required]);
			// this.headerForm.controls["category"].updateValueAndValidity();
		}
		if ((selected === "T" || selected === "SI" || selected === "SE") && this.entityType !== "G") {
			
			this.isOtherNonGov = true;
			this.categoryhide = true;
			this.headerForm.controls["header"].enable();
			//this.headerForm.controls["header"].setValidators([Validators.required, Validators.pattern("^([a-zA-Z0-9]{3,6})$")]);
			this.headerForm.controls["header"].setValidators([Validators.required, Validators.pattern("^(?![0-9]*$)[a-zA-Z0-9]{3,6}$")])
			
			this.headerForm.controls["header"].updateValueAndValidity()

			// this.headerForm.controls["category"].enable();
			// this.headerForm.controls["category"].setValidators(Validators.nullValidator);
			// this.headerForm.controls["category"].updateValueAndValidity();

		}
		if ((selected === "T" || selected === "SI" || selected === "SE") && this.entityType == "G") {
			console.log("case 4");
			this.isOtherGov = true;
			this.categoryhide = true;
			this.headerForm.controls["header"].enable();
			//Added for Government
			//this.headerForm.controls["header"].setValidators([Validators.required, Validators.pattern("^([1]([0-9]{2,4}|[0-9]{6,7})|[A-Za-z]{3,6})$")]);
			this.headerForm.controls["header"].setValidators([Validators.required, Validators.pattern("^(1[0-9]{2,4})$|(?=.*[a-zA-Z])^([a-zA-Z0-9]{3,6})$")])
			this.headerForm.controls["header"].updateValueAndValidity();

			console.log("ctgrDisabled  ", this.ctgrDisabled);
			this.headerForm.controls["category"].enable();
			this.headerForm.controls["category"].setValidators(Validators.nullValidator);
			this.headerForm.controls["category"].updateValueAndValidity();
		}
		this.headerForm.controls["category"].updateValueAndValidity();
		this.headerForm.controls["header"].updateValueAndValidity();

	}


	resendOTP(val) {


		var mobileNum = this.headerForm.get("mobileno").value;
		var emailI = this.headerForm.get("header_email").value;
		let data = {
			EntityId: this.entityId,
			otpFor: val,
			mobileNum: mobileNum,
			emailI: emailI

		}

		this.hs.resendOTPForHeader(data)
			.subscribe((r) => {
				if (r.message == "OTP sent") {
					this.$modal.successModal({
						title: 'OTP Notification',
						msg: 'OTP has been resend successfully'
					});
				}
				else {
					this.$modal.errorModal({
						title: 'OTP Notification',
						msg: 'Error resending the OTP'
					});
				}

			})
	}


	submitUpdateReg() {


		var mobileNum = this.headerForm.get("mobileno").value;
		var emailI = this.headerForm.get("header_email").value;
		var EntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

		var hEmailFrmSession = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL);
		var hMobileFrmSession = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE);

		if (hEmailFrmSession == emailI && hMobileFrmSession == mobileNum) {
			//this.mobileEmailFlag = true;
			this.$modal.errorModal({
				title: 'Header Info:',
				msg: 'Please change Mobile Number/Email ID'
			});
		}
		else {
			//this.mobileEmailFlag = false;

			if (hEmailFrmSession == emailI) {
				emailI = ""
			}
			else if (hMobileFrmSession == mobileNum) {
				mobileNum = "";
			}


			let data = {
				mobileNumber: mobileNum,
				emailId: emailI,
				entityType: this.IndCategory,
				OrgName: this.OrgName,
				EntityId: EntityId

			}

			this.hs.updateMobileEmailInMongo(data)
				.subscribe((r) => {


					if (r.message == "Header Email/Mobile updated successfully") {

						if (r.mailStatus == true && r.mobileStatus !== true) {
							this.mailStatus = true;
							this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);
							//store the updated email in session 
						}
						else if (r.mobileStatus == true && r.mailStatus !== true) {
							this.mobileStatus = true;
							this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, this.mobileNumberSession);

						}
						else if ((r.mailStatus == true) && (r.mobileStatus == true)) {
							this.mailStatus = true;
							this.mobileStatus = true;
							this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, this.mobileNumberSession);
							this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, this.emailIdSession);

						}
						this.$modal.successModal({
							title: 'Email/Mobile Updation',
							msg: 'OTP has been send to the Email/Mobile. Please verify'
						});
					}
					else {
						this.$modal.errorModal({
							title: 'Email/Mobile Updation',
							msg: 'Error in Updating the Values'
						});
					}

				})
		}

	}

	verifyOTP(value) {

		var data;
		var EntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		console.log("value ", value);
		if (value == "Email") {
			var EmailOtp = this.headerForm.get("emailotpno").value;
			data = {
				"otpFor": value,
				"OTP": EmailOtp,
				"EntityId": EntityId
			}
		}
		else if (value == "Mobile") {
			console.log("--------");
			var MobileOtp = this.headerForm.get("mobileotpno").value;
			console.log("-------MobileOtp-", MobileOtp);
			data = {
				"otpFor": value,
				"OTP": MobileOtp,
				"EntityId": EntityId
			}
		}
		console.log("data ", data);
		// else if (this.mobileStatus) {
		// value = "Mobile";
		// data = {
		// "otpFor": value,
		// "emailOtp": "",
		// "mobileOtp": this.headerForm.get("emailotpno").value,
		// "EntityId": EntityId
		// }
		// }
		// else if(this.mailStatus && this.mobileStatus){ 
		// value = "bothME";
		// data = {
		// "otpFor": value,
		// "emailOtp": "",
		// "mobileOtp": this.headerForm.get("emailotpno").value,
		// "EntityId": EntityId
		// }
		// } 

		/* console.log("data ", data); */
		this.hs.sendEMOtpForHeader(data)
			.subscribe(r => {


				if (r.message == "success") {

					if (r.data.EmailId.length !== 0) {
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL, r.data.EmailId);
					}
					if (r.data.MobileNumber.length !== 0) {
						this.db.set(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE, r.data.MobileNumber);
					}


					this.$modal.successModal({
						title: 'Header OTP Verification',
						msg: 'OTP successfully Verified'
					});
					if (r.mobileStatus == true) {
						this.mobileStatus = false;
					}
					else if (r.emailStatus == true) {
						this.mailStatus = false;
					}

				}
				else if (r.message == "Time exceed") {
					this.$modal.errorModal({
						title: 'Header OTP Verification',
						msg: 'OTP Time limit Exceeded'
					});
				}
				else {
					this.$modal.errorModal({
						title: 'Header OTP Verification',
						msg: 'Invalid OTP'
					});
				}
			})

	}

	checkAvailability() {

		let validCheck = this.headerForm.controls;
		this.header_id = this.headerForm.get("header").value;
		let headerType = this.headerForm.get('headerType').value;
		if (headerType == "T" || headerType == "SI" || headerType == "SE") {
			headerType = "O";
		}

		let data = {
			"header_id": this.header_id,
			"headerType": headerType,
			"category": this.category,
			"EntityId": this.entityId
		}

		if (this.header_id.length <= 0) {
			this.$modal.errorModal({

				title: 'Header Availability',

				msg: 'Please enter a valid Header'

			});
			this.hTypeDisabled = false;
			//this.disableSelected = false;
		}
		//else{
		//else if (!validCheck["header"].invalid && !validCheck["category"].invalid) {
		//this.hs.checkAvailabilityOfHeader(this.header_id)
		else if (!validCheck["header"].invalid && !validCheck["headerType"].invalid) {
			this.hs.checkAvailabilityOfHeader(data)
				.subscribe((r) => {

					if (r.status == "msg") {
						this.headernonExistFlag = false;
						this.$modal.errorModal({

							title: 'Header Availability',

							msg: r.msg

						});

					}
					else if (r.status == "success") { //Added for Hclass (else)

						this.hTypeDisabled = true;

						this.headernonExistFlag = true;
						if (r.result.length > 0) {

							if (r.result == "F") {

								this.tmDisabled = false;
								this.headerForm.controls['tmid'].setValue(null);
								this.headerForm.controls['tmid'].enable();
								if (r.ctgr) {

									this.ctgrDisabled = true;
									this.category = parseInt(r.ctgr);
									this.headerForm.controls['category'].updateValueAndValidity();
								}
							}
							else {
								this.tmDisabled = true;
								this.headerForm.controls['tmid'].setValue(r.tmid);
								this.headerForm.controls['tmid'].disable();
								this.changeTMID(r.tmid);
								if (r.ctgr) {

									this.ctgrDisabled = true;
									this.category = parseInt(r.ctgr);
									this.headerForm.controls['category'].updateValueAndValidity();
								}
								else if (r.ctgr == "") {

									this.ctgrDisabled = true;
									this.category = undefined;

								}
							}

						}
						else {

							this.tmDisabled = false;
							this.category = undefined;
							this.headerForm.controls['category'].updateValueAndValidity();

						}
						this.$modal.successModal({

							title: 'Header Availability',

							msg: 'Header is Available'

						});

					}
					else if (r.result.length > 0) {

						//this.disableSelected = false;

						this.ctgrDisabled = false;
						this.tmDisabled = false;
						this.headernonExistFlag = false;

						this.headerForm.controls["tmid"].enable();
						//this.headerForm.controls["tmid"].setValidators(Validators.nullValidator);
						this.headerForm.controls["tmid"].setValidators(Validators.pattern("^[1-9][0-9]*$"));
						this.headerForm.controls["tmid"].updateValueAndValidity();
						this.headerForm.controls['tmid'].setValue(null);
						this.headerForm.controls["tm_name"].enable();
						this.headerForm.controls["tm_name"].setValidators(Validators.nullValidator);
						this.headerForm.controls["tm_name"].updateValueAndValidity();
						this.headerForm.controls['tm_name'].setValue("");

						this.$modal.errorModal({

							title: 'Header Availability',

							msg: "Header already exists & not available for registration"

						});
						this.hTypeDisabled = false;
					}
					else {
						this.headerForm.controls["tmid"].enable();
						//this.headerForm.controls["tmid"].setValidators(Validators.nullValidator);
						this.headerForm.controls["tmid"].setValidators(Validators.pattern("^[1-9][0-9]*$"));
						this.headerForm.controls["tmid"].updateValueAndValidity();
						this.headerForm.controls['tmid'].setValue(null);
						this.headerForm.controls["tm_name"].enable();
						this.headerForm.controls["tm_name"].setValidators(Validators.nullValidator);
						this.headerForm.controls["tm_name"].updateValueAndValidity();
						this.headerForm.controls['tm_name'].setValue("");

						this.hTypeDisabled = true;
						//this.disableSelected = true;

						this.ctgrDisabled = false;
						this.tmDisabled = false;
						this.headernonExistFlag = true;
						this.$modal.successModal({

							title: 'Header Availability',

							msg: 'Header is Available'

						});
					}

				})

		}
		else {
			this.$modal.errorModal({

				title: 'Header Availability',

				msg: 'Please Enter a Valid Header'

			});
		}
	}


	onSubmit() {

		this.headerForm.controls["mobileotpno"].setValidators(Validators.nullValidator);
		this.headerForm.controls["emailotpno"].setValidators(Validators.nullValidator);
		this.headerForm.controls["mobileotpno"].updateValueAndValidity();
		this.headerForm.controls["emailotpno"].updateValueAndValidity();




		if (this.headerForm.invalid || (this.isNumCheckadres2) || (this.isNumCheckadres1) || this.fileExtensionError ||
			this.fileSizeError1 || this.fileSizeError2 || this.file1ExtensionError || this.file1SizeError1 ||
			this.file1SizeError2 || this.categoryErr == true) {
			console.log("invalid form", this.headerForm);
			return;
		}
		else if (this.headernonExistFlag == false) {
			this.$modal.errorModal({

				title: 'Header Availability',

				msg: 'Header Already exists. Please use a different header.'

			});
		}
		else if (!this.tmidFlag) {
			this.$modal.errorModal({
				title: 'TM ID',
				msg: 'You have entered invalid TM ID, either enter correct ID or proceed without TM ID'
			});

		}
		else {

			this.bw.checkBadWord(this.headerForm.get('header').value)

				.subscribe(r => {

					if (r.Data.isValid == 'Invalid') {

						this.$modal.errorModal({

							title: 'Restricted words',

							msg: 'Please use a different header.'

						});

					}

					else {

						this.APIcreateHeader();

					}



				});
		}
	}


	resetDoc(id) {


		if (id == "doc1") {
			this.fileExtensionError = false;

			this.fileSizeError1 = false;
			this.fileSizeError2 = false;
			this.headerForm.controls['uploader'].reset();
			this.document1 = [];
		}
		else {
			this.file1ExtensionError = false;
			this.file1SizeError1 = false;
			this.file1SizeError2 = false;
			this.headerForm.controls['uploader1'].reset();
		}

	}




	//upload funcion new code

	onChangeFileUpload(event, id) {

		this.myfiles = event.target.files;
		var file = event.target.files[0];
		//console.log("photoname1" + this.photoName1);
    let fileNameArr = file.name.split('.')
		if (fileNameArr.length > 2) {
			this.$modal.errorModal({
				title: 'Header Registration',
				msg: "Can't upload file with two extension!, please upload again."
			})
			if (id == "doc1") {
				this.resetDoc1()
			}
			else if (id == "doc2") {
				this.resetDoc2()
			}
		}else{
      if (id == "doc1") {
        this.photoName = file.name;
        this.docfiles1 = this.document1.push(file);
      }
      else if (id == "doc2") {
        // this.myfilesother1.push(event.target.files[0])
        this.photoName1 = file.name;
  
        this.docfiles2 = this.document2.push(file)
      }
      if (id == "doc1") {
  
  
        if (file.size > 4242880) {
          //console.log("The size is more ")
          this.fileSizeError1 = true;
        }
        else {
          this.fileSizeError1 = false;
        }
        if (file.size <= 0) {
          //console.log("The size is less ")
          this.fileSizeError2 = true;
        }
        else {
          this.fileSizeError2 = false;
        }
      }
  
      if (id == "doc2") {
        if (file.size > 4242880) {
          //console.log("The size is more ")
          this.file1SizeError1 = true;
        }
        else {
          this.file1SizeError1 = false;
        }
        if (file.size <= 0) {
          //console.log("The size is less ")
          this.file1SizeError2 = true;
        }
        else {
          this.file1SizeError2 = false;
        }
      }
      var allowedExtensions =
        ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf", "PNG"];
      this.fileExtension = file.name.split('.').pop();
  
  
  
      if (id == "doc1") {
        if (this.isInArray(allowedExtensions, this.fileExtension)) {
          this.fileExtensionError = false;
          this.fileExtensionMessage = ""
        } else {
          this.fileExtensionMessage = "Only photos allowed!!"
          this.fileExtensionError = true;
        }
      }
      if (id == "doc2") {
        if (this.isInArray(allowedExtensions, this.fileExtension)) {
          this.file1ExtensionError = false;
          this.file1ExtensionMessage = ""
        } else {
          this.file1ExtensionMessage = "Only photos allowed!!"
          this.file1ExtensionError = true;
        }
      }
  
      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

		//console.log("this is file extension error", this.fileExtensionError);
	}



	fileRead(photoNam, fil) {
		var allowedExtensions =
			["jpg", "pdf"];
		this.fileExtension = photoNam.split('.').pop();

		if (this.isInArray(allowedExtensions, this.fileExtension)) {
			this.fileExtensionError = false;
			this.fileExtensionMessage = ""
		} else {
			this.fileExtensionMessage = "Only photos allowed!!"
			this.fileExtensionError = true;
		}

		if (fil) {
			var reader = new FileReader();
			reader.onloadend = (e: any) => {
				var contents = e.target.result;
				this.photoContent = contents;
			}
			reader.readAsDataURL(fil);
		} else {
			alert("Failed to load file");
		}
	}

	addDocument() {
		if (this.addDocFlag == true) {
			this.errDoc = true;
		}
		else {
			this.addDocFlag = true;
		}
	}

	resetform() {
		//this.headerForm.reset();
		console.log("Clear" + this.hTypeDisabled)

		//Added for Hclass
		this.headerForm.controls['hclass'].reset();
		this.headerForm.controls['validity'].reset();

		//this.headerForm.controls['mobileno'].reset();
		//this.headerForm.controls['header_email'].reset();
		this.headerForm.controls['category'].reset();
		this.headerForm.controls['nature_business'].reset();
		this.headerForm.controls['doc_type'].reset();
		this.headerForm.controls['uploader'].reset();
		this.headerForm.controls['doc_type1'].reset();
		this.headerForm.controls['uploader1'].reset();
		this.headerForm.controls['tmid'].reset();
		this.headerForm.controls['tm_name'].reset();
		this.headerForm.controls['desc_header'].reset();

		this.headerForm.controls["headerType"].enable();
		this.headerForm.controls["header"].enable();
		this.headerForm.controls["headerType"].reset();
		this.headerForm.controls["header"].reset();
		this.headerForm.controls["headerType"].setValue(null);
		this.headerForm.controls["header"].setValue(null);
		this.hTypeDisabled = false;
		this.ctgrDisabled = false;
		this.tmDisabled = false;
		this.headernonExistFlag = false;
		this.categoryErr = false;
		console.log("Clear tm " + this.hTypeDisabled, this.tmDisabled)

	}


	resetDoc1() {
		console.log('this.headerForm.get("uploader").value', this.headerForm.get("uploader").value)
		this.headerForm.controls['uploader'].reset();
		this.document1 = [];
		console.log('this.headerForm.get("uploader").value', this.headerForm.get("uploader").value)
		this.docfiles1 = null;
		this.fileExtensionError = false;
		this.fileSizeError1 = false;
		this.fileSizeError2 = false;

	}

	resetDoc2() {
		this.document2 = [];

		this.headerForm.controls['uploader1'].reset();
		this.docfiles2 = null;
		this.file1ExtensionError = false;
		this.file1SizeError1 = false;
		this.file1SizeError2 = false;
	}
	APIcreateHeader() {


		var hid;
		this.headerN = this.headerForm.get("header").value;
		let natureofB = this.headerForm.get("nature_business").value;

		//Added for Hclass
		let hclass = this.headerForm.get("hclass").value;
		let validity = this.headerForm.get("validity").value;

		console.log(hclass,validity)

		let doc_type = this.headerForm.get("doc_type").value;
		let doc_type1 = this.headerForm.get("doc_type1").value;
		let document1 = this.headerForm.get("uploader").value;
		let document2 = this.headerForm.get("uploader1").value;
		let desc_header = this.headerForm.get("desc_header").value;

		//console.log("document ", document);
		console.log("this.document1[0]", this.document1[0]);
		this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		let headerTypeJson = this.headerForm.get('headerType').value;
		this.selectedValue = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
		//console.log("this.selectedValue : ", this.selectedValue);

		let Entity_ContactName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME);
		let E_Org_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
		const today = new Date();
		const ranvalue = today.getTime();
		//hid = '1605' + ranvalue;
		hid = ranvalue;


		const headerForm: FormData = new FormData();

		let email = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_EMAIL);
		let mobile = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_MOBILE);
		var IndType;
		let IndCatg = this.headerForm.get("industry_category").value;
		switch (IndCatg) {
			case 'Government':
				IndType = "G";
				break;
			case 'Private':
				IndType = "P";
				break;
			case 'SEBI':
				IndType = "S";
				break;
			case 'Public Limited Company':
				IndType = "U";
				break;
			case 'Others':
				IndType = "O";
				break;
			default:
				IndType = "";
				break;
		}

		let Industry = this.headerForm.get("industry_type").value;
		let Sector = this.headerForm.get("industry_sector").value;


		headerForm.append('IndustryType', IndType);
		if (Industry) {
			headerForm.append('Industry', Industry);
		}
		else {
			headerForm.append('Industry', "");
		}
		headerForm.append('Sector', Sector);
		headerForm.append('entityname', Entity_ContactName);
		headerForm.append('entityType', "Principal Entity");
		headerForm.append('OrgName', E_Org_Name);
		headerForm.append('peid', this.principalEntityId);
		headerForm.append('htyp', headerTypeJson);
		headerForm.append('cli', this.headerN);
		if (this.category == undefined || this.category == null) {
			headerForm.append('ctgr', "");

		}
		else {
			headerForm.append('ctgr', this.category);
		}

		//let tmid = this.headerForm.get("tmid").value;

		if (this.tmidFlag) {

			console.log("this.tmidDltin ", this.tmidDlt);
			if (this.tmidDlt) {
				headerForm.append('tmid', this.tmidDlt);
				let tmName = this.headerForm.get("tm_name").value;
				headerForm.append('tmName', tmName);
			}
			else {
				headerForm.append('tmid', "");
			}


		}
		else {
			headerForm.append('tmid', "");

		}

		//Added for Hclass
		headerForm.append('hclass', hclass);
		headerForm.append('validity', validity);

		headerForm.append('natureofB', natureofB);
		headerForm.append('doc_type', doc_type);
		headerForm.append('doc_type1', doc_type1);
		headerForm.append('document1', this.document1[0]);
		headerForm.append('document2', this.document2[0]);
		headerForm.append('desc_header', desc_header);
		headerForm.append('hidd', hid);
		//headerForm.append('tmid', "0");
		headerForm.append('Email', email);
		headerForm.append('mobileNumber', mobile);

		//console.log("data displaying :", headerForm);
		this.hs.headerRegistrationnew(headerForm).subscribe(r => {
			if (r.status == false) {
				//this.router.navigateByUrl('/headers-by-pe');
				this.$modal.errorModal({
					title: 'Header Registration',
					msg: r.message
				});

			}
			else if (r.status == true) {
				this.headerForm.reset();
				this.$modal.successModal({
					title: 'Header Registration',
					msg: 'Your request for new Header is registered with us and is pending for approval. We shall revert to you in 24 working hours. Your URN is ' + r.urn
				});
				this.router.navigateByUrl('/headers-by-pe');

			}
			else {
				{
					// this.router.navigateByUrl('/headers-by-pe');
					this.$modal.errorModal({
						title: 'Header Registration',
						msg: 'Please try again, Error Trying to register Header'
					});

				}
			}
		})

	}

}//end of export